import styled from "styled-components"
import * as PropTypes from "prop-types"
import Link from "components/Link"
import { SecondaryButton } from "components/styled/Buttons/SecondaryButton"
import { Container } from "../../../components/styled/Grid"
import Typography from "../../../components/styled/Typography";

const Text = styled(Typography)`
  margin-top: 15px;
  @media ${({ theme }) => theme.breakpoints.md} {
    margin-top: 25px;
  }
`
const Wrapper = styled.div`
  margin-bottom: 5px;
  @media ${({ theme }) => theme.breakpoints.md} {
    margin-bottom: 25px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
`

const HtmlContent = styled.div`
  p {
    margin: 0;
  }
`

const StyledButton = styled(SecondaryButton)`
  margin-top: 25px;
`

const getMainText = (mainText, seoData) => {
  if (seoData?.page_category !== "cities" || typeof mainText !== "string") {
    return mainText
  }

  // ponytail: SEO text is trusted CMS HTML; if arbitrary HTML grows, replace this with an HTML AST transform.
  return mainText
    .replace(/<h2(\s[^>]*)?>/gi, "<h3$1>")
    .replace(/<\/h2>/gi, "</h3>")
}

export default function WhyRenting({ section, seoData }) {
  const { title, main_text, show_button, button_text, button_url } = section
  const hasTitle = typeof title === "string" && title.trim().length > 0
  const mainText = getMainText(main_text, seoData)

  return (
    <Container bottom={25} top={25}>
      <Wrapper>
        {hasTitle && (
          <Typography variant="title2" weight="medium" center>
            {title}
          </Typography>
        )}
        <Text weight="light" as="div">
          <HtmlContent dangerouslySetInnerHTML={{ __html: mainText }} />
        </Text>
        {show_button && (
          <Link href={button_url}>
            <StyledButton size="lg" border>
              {button_text}
            </StyledButton>
          </Link>
        )}
      </Wrapper>
    </Container>
  )
}

WhyRenting.propTypes = {
  section: PropTypes.object.isRequired,
  seoData: PropTypes.object
}

WhyRenting.defaultProps = {
  seoData: null
}
